import React, { useContext, useEffect, useRef, useState } from 'react'
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import ImageLoad from '../ImageLoad';
import { Link } from 'react-router-dom';
import EmptyOrderLogo from "../../image/emptyOrder.png";
import PageLoading from '../PageLoading';
import { useTranslation } from 'react-i18next';
const Following = () => {

    const { t } = useTranslation();
    const { BaseUrl, HandleCallApi } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [followingList, setFollowingList] = useState([]);

    const FollowingRef = useRef(false);

    useEffect(() => {
        handleGetFollowing();
    }, []);

    const handleGetFollowing = async () => {
        if (FollowingRef.current) return;
        FollowingRef.current = true;
        const Userid = secureLocalStorage.getItem("Userid");
        const Response = await HandleCallApi("Post", "user/my_follwing", { id: Userid });
        setFollowingList(Response.data.following);
        setLoading(false);
    }

    return (
        <div>

            {!loading && <div className="width_container">
                <div className="py-[15px] leading-4">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">{t("My Followings")}</h1>
                    <p className="text-gray-800 text-[16px]">{t("You are following")} {followingList?.length} {t("people")}
                    </p>
                </div>
                <div className="mt-[20px]">
                    {followingList.length >= 1
                        ? <div className="grid grid-cols-4 max-_969_:grid-cols-2 max-_1405_:grid-cols-3  gap-6 mt-[20px]">
                            {followingList?.map((item, index) => {
                                return <Link to={`/astrologers/${item.id}`}
                                    state={{ title: "Chat-with-astrologer", astrologer_id: item.id }} key={index} className="bg-white px-[20px] py-[15px] rounded-[15px] flex items-start gap-[10px] shadow gorup hover:shadow-lg duration-300">
                                    <div className="max-w-[80px] min-w-[80px] text-center">
                                        <ImageLoad url={BaseUrl + item.image} CustomeStyle={"w-full h-[80px] object-cover border rounded-full"} alt={`${item.name} Image`} />
                                        <div className="flex items-center gap-[5px] justify-center mt-[4px]">
                                            <svg width="14" height="14" className="text-[--bgcolor]" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.96065 0.59625L11.9027 4.51324C12.0487 4.80824 12.3307 5.01226 12.6577 5.05926L17.1406 5.70721C17.9626 5.82621 18.2906 6.83423 17.6956 7.41223L14.4547 10.5572C14.2177 10.7872 14.1096 11.1182 14.1656 11.4432L14.9066 15.7473C15.0566 16.6203 14.1396 17.2862 13.3536 16.8752L9.46566 14.8403C9.17366 14.6873 8.82563 14.6873 8.53463 14.8403L4.64962 16.8732C3.86262 17.2852 2.94259 16.6182 3.09359 15.7432L3.83468 11.4432C3.89068 11.1182 3.78261 10.7872 3.54561 10.5572L0.304646 7.41223C-0.291354 6.83423 0.0365773 5.82621 0.859577 5.70721L5.34261 5.05926C5.66861 5.01226 5.95061 4.80824 6.09761 4.51324L8.03963 0.59625C8.43063 -0.19875 9.56665 -0.19875 9.96065 0.59625Z" fill="currentColor"></path></svg>
                                            <span className="font-medium text-[15px] text-gray-700">{item.rating}</span>
                                        </div>
                                        <p className="text-[14px] text-gray-500">{item.torder} {t("orders")}</p>
                                    </div>
                                    <div className="w-full leading-[22px] overflow-hidden">
                                        <div className="flex items-center gap-[10px] justify-between">
                                            <h1 className="text-[17px] trime font-medium group-hover:text-green-500">{item.name}</h1>
                                            {item.vstatus === 1 && <div className="text-green-600">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                                                    <path d="m9 11 3 3L22 4"></path>
                                                </svg>
                                            </div>}
                                        </div>
                                        <p className="text-[14px] text-gray-600 trime">{item.skills}</p>
                                        <p className="text-[14px] text-gray-600 trime">{item.lang}</p>
                                        <p className="text-[14px] text-gray-600">{t("Exp")}: {item.experience} {t("Years")}</p>
                                    </div>
                                </Link>
                            })}
                        </div>
                        : <div className="flex items-center justify-center pt-[50px]">
                            <div className="text-center">
                                <img src={EmptyOrderLogo} className='w-[200px] mx-auto' alt="EmptyOrderLogo" />
                                <h1 className='font-medium text-[18px]'>{t("No Following Found !!")}</h1>
                                <p className='text-gray-600 text-[15px]'>{t("Currently you don't have any follow.")}</p>
                            </div>
                        </div>}
                </div>
            </div>}

            <PageLoading loading={loading} />

        </div>
    )
}

export default Following